import { CssBaseline, ThemeProvider } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute"; // Import ProtectedRoute
import ToastProvider from "./components/Toast";
import Dashboard from "./containers/dashboard";
import { getTheme } from "./theme";
import LoginPage from "./containers/Login";
import Doctor from "./containers/doctor";
import Clinic from "./containers/clinic";
import Users from "./containers/users";
import Settings from "./containers/Settings";
import UserTests from "./containers/userTests";
import TestPage from "./containers/testPage";
import DoctorDetail from "./containers/DoctorDetail";
import ClinicDetail from "./containers/ClinicDetails";
const App = () => {
  const [themeMode, setThemeMode] = useState(() => {
    return localStorage.getItem('theme') || 'light';
  });
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoadingAuthCheck, setIsLoadingAuthCheck] = useState(true);
  
  useEffect(() => {
    const token = localStorage.getItem("token");
  
    if (token) {
      setIsAuthenticated(true);     // Restore login state on refresh
    } else {
      setIsAuthenticated(false);    // First visit → force login
    }
  
    setIsLoadingAuthCheck(false);
  }, []);
  
  

  const toggleTheme = () => {
    setThemeMode((prevMode) => {
      const newMode = prevMode === 'light' ? 'dark' : 'light';
      localStorage.setItem('theme', newMode);
      return newMode;
    });
  };
  const theme = getTheme(themeMode);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("entityId");
    setIsAuthenticated(false);
  };
  
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ToastProvider>
        <Router>
          <Routes>
            {/* Redirect from '/' to '/login' */}
            <Route path="/" element={<Navigate to="/login" replace />} />    {/* here aand in components/protectedRoutes change loginPath */}
           
            {/* Login route */}
            <Route
              path="/login"
              element={<LoginPage onLogin={handleLogin} />}
            />

            {/* Protected routes */}
            
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated} isLoadingAuthCheck={isLoadingAuthCheck}>
                  <Dashboard onLogout={handleLogout} />
                </ProtectedRoute>
              }
            >
               <Route
                path="/dashboard/doctor"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated} isLoadingAuthCheck={isLoadingAuthCheck}>
                    <Doctor />
                  </ProtectedRoute>
                }
              />
               <Route
                path="/dashboard/doctor/doctorDetails/:id"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated} isLoadingAuthCheck={isLoadingAuthCheck}>
                    <DoctorDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/clinic/clinicDetails/:id"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated} isLoadingAuthCheck={isLoadingAuthCheck}>
                    <ClinicDetail />
                  </ProtectedRoute>
                }
              />
               <Route
                path="/dashboard/clinic"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated} isLoadingAuthCheck={isLoadingAuthCheck}>
                    <Clinic />
                  </ProtectedRoute>
                }
              />
               <Route
                path="/dashboard/user"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated} isLoadingAuthCheck={isLoadingAuthCheck}>
                    <Users />
                  </ProtectedRoute>
                }
              />
               <Route
                path="/dashboard/user/:id"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated} isLoadingAuthCheck={isLoadingAuthCheck}>
                    <UserTests />
                  </ProtectedRoute>
                }
              />
               <Route
                path="/dashboard/user/test/:id"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated} isLoadingAuthCheck={isLoadingAuthCheck}>
                    <TestPage />
                  </ProtectedRoute>
                }
              />
               <Route
                path="/dashboard/settings"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated} isLoadingAuthCheck={isLoadingAuthCheck}>
                    <Settings themeMode={themeMode} toggleTheme={toggleTheme} />
                  </ProtectedRoute>
                }
              />
              
            </Route>
          </Routes>
        </Router>
      </ToastProvider>
    </ThemeProvider>
  );
};

export default App;
